import { useContext } from 'react'
import { es } from 'date-fns/locale'

import { Globals } from '@h2/globals'

/**
 * recommended method for getting the DateFNS locale
 * @param value
 * @returns {undefined}
 */
export const useDateFnsLocale = () => {
  const { userProfile } = useContext(Globals)
  const guessLocale = () => {
    const langId = userProfile.languageId?.replace('_', '-') || 'en-US'

    if (langId.toLowerCase().includes('es')) {
      return { locale: es }
    }

    return {}
  }

  return guessLocale()
}
